import { Button } from '@/components/ui/button'
import React from 'react'

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-custom"></div>
        <img
          src="https://images.pexels.com/photos/7681091/pexels-photo-7681091.jpeg"
          alt="Análise de negócios"
          className="w-full h-full object-cover opacity-30"
        />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-6 leading-tight">
            <span className="block">Transforme Impostos</span>
            <span className="block text-foreground ">Em Oportunidades de Negócio</span>
          </h1>
          <p className="text-xl text-muted-foreground mb-8 leading-relaxed">
            Pare de perder dinheiro com impostos. Nossa equipe de especialistas ajuda empresas a recuperar impostos
            pagos em excesso e implementar planejamento estratégico para melhorar o fluxo de caixa.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <Button
              size="lg"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Consulta Gratuita
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
